import { Controller } from "@hotwired/stimulus"

// Fiches slider: tab nav + carousel translate + keyboard arrows. Cards across the page
// (collection, casting, hero pills) trigger goToSign via a Stimulus action. Ported from
// the designer LP's inline slider IIFE. Classic JS only (old Babel — no ?./??).
export default class extends Controller {
  connect() {
    this.section = document.getElementById("fiches")
    this.track = document.getElementById("fiches-track")
    if (!this.track) return
    this.slides = Array.prototype.slice.call(this.track.querySelectorAll(".fiche"))
    this.order = this.slides.map((s) => s.dataset.sign)
    this.tabs = Array.prototype.slice.call(document.querySelectorAll(".fiches-tab"))
    this.cur = 0

    this.tabs.forEach((t, i) => {
      t.addEventListener("click", () => this.goTo(i, false, true))
    })

    this.onKeydown = (e) => this.handleKey(e)
    document.addEventListener("keydown", this.onKeydown)

    this.goTo(0, false, false)
  }

  disconnect() {
    if (this.onKeydown) document.removeEventListener("keydown", this.onKeydown)
  }

  // data-action target: a card/pill/tab with data-sign opens the slider on that sign.
  goToSign(event) {
    event.preventDefault()
    const el = event.currentTarget
    const slug = el.dataset.sign
    const i = this.order.indexOf(slug)
    if (i >= 0) this.goTo(i, true, true)
  }

  goTo(i, pageScroll, centerTab) {
    if (!this.track) return
    this.cur = (i + this.slides.length) % this.slides.length
    this.track.style.transform = "translateX(" + (-this.cur * 100) + "%)"

    this.tabs.forEach((t, j) => {
      const on = j === this.cur
      t.classList.toggle("is-active", on)
      t.setAttribute("aria-selected", on ? "true" : "false")
      t.style.borderBottomColor = on ? (t.dataset.color || "") : ""
    })

    document.querySelectorAll(".astro-pill").forEach((p) => {
      p.classList.toggle("is-active", p.dataset.sign === this.order[this.cur])
    })

    if (centerTab && this.tabs[this.cur]) {
      this.tabs[this.cur].scrollIntoView({ inline: "center", block: "nearest", behavior: "smooth" })
    }

    if (pageScroll && this.section) {
      const tabsWrap = this.section.querySelector(".fiches-tabswrap")
      const anchor = tabsWrap || this.section
      const top = anchor.getBoundingClientRect().top + window.pageYOffset - 20
      window.scrollTo({ top: top, behavior: "smooth" })
    }
  }

  handleKey(e) {
    if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return
    if (!this.section) return
    const r = this.section.getBoundingClientRect()
    if (r.bottom < 80 || r.top > window.innerHeight - 80) return
    this.goTo(this.cur + (e.key === "ArrowRight" ? 1 : -1), false, true)
  }
}
